(function () {

  function initJourneySlider() {

    const slider = document.getElementById('journeyCardSlider');

    if (!slider) return;

    if (slider.dataset.journeyReady === 'true') return;

    slider.dataset.journeyReady = 'true';


    const slides = Array.from(
      slider.querySelectorAll('.journey-card-slide')
    );

    const prevButton =
      slider.querySelector('.journey-card-prev');

    const nextButton =
      slider.querySelector('.journey-card-next');

    const currentCounter =
      slider.querySelector('.journey-card-current');

    const totalCounter =
      slider.querySelector('.journey-card-total');

    const lightbox =
      document.getElementById('gallery-lightbox');


    if (!slides.length) return;


    const AUTOPLAY_DELAY = 5000;
    const MANUAL_COOLDOWN = 3000;


    let currentIndex = 0;

    let autoplayTimer = null;
    let cooldownTimer = null;

    let touchStartX = null;
    let touchStartY = null;

    let lightboxOpen = false;


    /* =========================================
       COUNTER
       ========================================= */

    if (totalCounter) {
      totalCounter.textContent = slides.length;
    }


    /* =========================================
       LOAD DEFERRED IMAGE
       ========================================= */

    function loadImage(index) {

      index =
        (index + slides.length) %
        slides.length;


      const image =
        slides[index].querySelector('img');


      if (!image) return;


      const deferredSrc =
        image.getAttribute('data-src');


      if (!deferredSrc) return;


      image.src = deferredSrc;

      image.removeAttribute('data-src');

    }


    /* =========================================
       SHOW SLIDE
       ========================================= */

    function showSlide(index) {

      currentIndex =
        (index + slides.length) %
        slides.length;


      /* Load current image */

      loadImage(currentIndex);


      /* Preload next image */

      loadImage(
        (currentIndex + 1) %
        slides.length
      );


      slides.forEach(function (slide, index) {

        const active =
          index === currentIndex;


        slide.classList.toggle(
          'is-active',
          active
        );


        slide.setAttribute(
          'aria-hidden',
          active ? 'false' : 'true'
        );

      });


      if (currentCounter) {

        currentCounter.textContent =
          currentIndex + 1;

      }

    }


    /* =========================================
       NEXT / PREVIOUS
       ========================================= */

    function nextSlide() {

      showSlide(
        currentIndex + 1
      );

    }


    function previousSlide() {

      showSlide(
        currentIndex - 1
      );

    }


    /* =========================================
       TIMERS
       ========================================= */

    function stopAutoplay() {

      if (autoplayTimer !== null) {

        window.clearTimeout(
          autoplayTimer
        );

        autoplayTimer = null;

      }

    }


    function clearCooldown() {

      if (cooldownTimer !== null) {

        window.clearTimeout(
          cooldownTimer
        );

        cooldownTimer = null;

      }

    }


    /* =========================================
       AUTOPLAY

       Wait 5 seconds, change one slide,
       then schedule another 5 seconds.
       ========================================= */

    function scheduleAutoplay() {

      stopAutoplay();


      if (
        lightboxOpen ||
        document.hidden
      ) {
        return;
      }


      autoplayTimer =
        window.setTimeout(
          function () {

            autoplayTimer = null;

            nextSlide();

            scheduleAutoplay();

          },
          AUTOPLAY_DELAY
        );

    }


    /* =========================================
       MANUAL COOLDOWN

       Manual click/swipe:
       - change immediately
       - stop autoplay
       - wait 3 sec
       - restart normal 5-sec timer
       ========================================= */

    function manualCooldown() {

      stopAutoplay();

      clearCooldown();


      cooldownTimer =
        window.setTimeout(
          function () {

            cooldownTimer = null;

            scheduleAutoplay();

          },
          MANUAL_COOLDOWN
        );

    }


    /* =========================================
       PREVIOUS BUTTON
       ========================================= */

    if (prevButton) {

      prevButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();


          previousSlide();

          manualCooldown();

        }
      );

    }


    /* =========================================
       NEXT BUTTON
       ========================================= */

    if (nextButton) {

      nextButton.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();


          nextSlide();

          manualCooldown();

        }
      );

    }


    /* =========================================
       TOUCH START
       ========================================= */

    slider.addEventListener(
      'touchstart',
      function (event) {

        if (!event.changedTouches.length) {
          return;
        }


        touchStartX =
          event.changedTouches[0].clientX;

        touchStartY =
          event.changedTouches[0].clientY;

      },
      {
        passive: true
      }
    );


    /* =========================================
       TOUCH END
       ========================================= */

    slider.addEventListener(
      'touchend',
      function (event) {

        if (
          touchStartX === null ||
          touchStartY === null ||
          !event.changedTouches.length
        ) {
          return;
        }


        const endX =
          event.changedTouches[0].clientX;

        const endY =
          event.changedTouches[0].clientY;


        const differenceX =
          touchStartX - endX;

        const differenceY =
          touchStartY - endY;


        touchStartX = null;
        touchStartY = null;


        /*
         * Ignore vertical page scrolling.
         */

        if (
          Math.abs(differenceX) <=
          Math.abs(differenceY)
        ) {
          return;
        }


        /*
         * Ignore tiny movements.
         */

        if (
          Math.abs(differenceX) < 45
        ) {
          return;
        }


        if (differenceX > 0) {

          nextSlide();

        } else {

          previousSlide();

        }


        manualCooldown();

      },
      {
        passive: true
      }
    );


    /* =========================================
       LIGHTBOX COORDINATION
       ========================================= */

    if (
      lightbox &&
      typeof MutationObserver !== 'undefined'
    ) {

      const observer =
        new MutationObserver(
          function () {

            const open =
              !lightbox.hasAttribute('hidden');


            /*
             * Lightbox opened.
             */

            if (open) {

              lightboxOpen = true;

              stopAutoplay();

              clearCooldown();

              return;

            }


            /*
             * Lightbox closed.
             */

            if (
              !open &&
              lightboxOpen
            ) {

              lightboxOpen = false;

              manualCooldown();

            }

          }
        );


      observer.observe(
        lightbox,
        {
          attributes: true,
          attributeFilter: ['hidden']
        }
      );

    }


    /* =========================================
       TAB VISIBILITY
       ========================================= */

    document.addEventListener(
      'visibilitychange',
      function () {

        if (document.hidden) {

          stopAutoplay();

          clearCooldown();

        } else if (!lightboxOpen) {

          scheduleAutoplay();

        }

      }
    );


    /* =========================================
       INITIALIZE
       ========================================= */

    showSlide(0);

    scheduleAutoplay();

  }


  /* =========================================
     START
     ========================================= */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initJourneySlider
    );

  } else {

    initJourneySlider();

  }


  /* Shopify theme editor */

  document.addEventListener(
    'shopify:section:load',
    initJourneySlider
  );

})();